import React from "react";
import Label from "@library/label";
import cn from "classnames";
import "@library/boolean-row/styles/index";

const STATES: { value: boolean | null; label: string }[] = [
  { value: null, label: "Unset" },
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

function Segmented(props: {
  disabled?: boolean;
  value: boolean | null;
  label: any;
  description?: string;
  id?: string;
  onChange?: (value: boolean | null) => void;
}) {
  const current = props.value ?? null;

  return (
    <div
      data-cy="boolean-row-segmented"
      className="editor__boolean-row editor__boolean-row--segmented"
    >
      <div className="editor__boolean-row__copy">
        <Label cy="boolean-row-label" id={props.id} text={props.label} />
        {props.description && (
          <span
            className="editor__boolean-row__description"
            data-cy="boolean-row-description"
          >
            {props.description}
          </span>
        )}
      </div>

      <div
        className="editor__boolean-row__segments"
        data-cy="boolean-row-controls"
        role="group"
        aria-label={typeof props.label === "string" ? props.label : undefined}
      >
        {STATES.map((state) => (
          <button
            key={state.label}
            type="button"
            aria-pressed={current === state.value}
            disabled={props.disabled}
            data-cy={"boolean-row-" + String(state.value)}
            className={cn("editor__boolean-row__segment", {
              "editor__boolean-row__segment--active": current === state.value,
            })}
            onClick={() => props.onChange(state.value)}
          >
            {state.label}
          </button>
        ))}
      </div>
    </div>
  );
}

Segmented.displayName = "BooleanRowSegmented";

export default Segmented;
